import { useEffect, useState } from 'react';
import { Navigate, NavLink, Outlet } from 'react-router-dom';
import { currentUser } from '../api/auth';
import Header from '../components/Header';
import { t } from '../lib/i18n';
import type { User } from '../api/types';

/**
 * Two-tab umbrella for the v2.25 Sales surface. /sales renders the existing
 * Sales content via its index route; /sales/devoluciones renders the new
 * returns page. Same role-gating as the legacy /sales route (everyone with
 * a session can see it — the daemon still applies cost-strip for staff).
 */
export default function SalesLayout() {
  const [user, setUser] = useState<User | null | undefined>(undefined);
  useEffect(() => {
    let alive = true;
    currentUser()
      .then((u) => { if (alive) setUser(u); })
      .catch(() => { if (alive) setUser(null); });
    return () => { alive = false; };
  }, []);
  if (user === undefined) return null;
  if (!user) return <Navigate to="/login" replace />;

  const tabClass = ({ isActive }: { isActive: boolean }) =>
    'inline-flex items-center px-3 py-2 text-sm border-b-2 -mb-px ' +
    (isActive
      ? 'border-tremor-brand text-tremor-content-strong font-semibold'
      : 'border-transparent text-tremor-content hover:text-tremor-content-strong');

  return (
    <div className="min-h-screen flex flex-col">
      <Header user={user} storeFilter />
      <main className="flex-1 px-6 py-6 space-y-4 max-w-screen-2xl mx-auto w-full">
        <div className="border-b border-tremor-border flex gap-1 overflow-x-auto">
          <NavLink to="/sales" end className={tabClass}>{t.sales.tabs.sales}</NavLink>
          <NavLink to="/sales/devoluciones" className={tabClass}>{t.sales.tabs.returns}</NavLink>
          <NavLink to="/sales/cotizaciones" className={tabClass}>{t.sales.tabs.quotes}</NavLink>
        </div>
        <Outlet context={user} />
      </main>
    </div>
  );
}
